import { Component, OnInit, inject } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FaviconService } from '@services/favicon.service';
import { ThemeService } from '@services/theme.service';
import { RoutingPath } from 'mbs-ui-shared@constants';
import { filter } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  private router = inject(Router);
  // Eagerly initialize ThemeService so data-bs-theme is set on <html> before any route renders,
  // including the Login page which does not have AppHeaderComponent.
  private readonly _theme = inject(ThemeService);
  private readonly favicon = inject(FaviconService);

  ngOnInit() {
    // temporary add redirect to web-connect
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationStart),
        untilDestroyed(this)
      )
      .subscribe((event) => {
        if (event.url.includes(`AP/${RoutingPath.Connect}`)) {
          location.href = `/WebConnect${location.search}`;
        }
      });
  }
}
